import request from '@/utils/request';

export function analysis(data) {
  return request({
    url: '/report/analysis',
    method: 'post',
    data,
  });
}

export function reportData(data) {
  return request({
    url: 'report/data',
    method: 'post',
    data,
  });
}

export function operateReceiveMail(data) {
  return request({
    url: 'mail/operateMerchantReportReceiveMail',
    method: 'post',
    data,
  });
}

// 检测邮箱
export function checkMerchantMail(params) {
  return request({
    url: '/mail/checkMerchantMail',
    method: 'get',
    params,
  });
}

// 邮箱列表查询
export function listMerchantReceiveMail(params) {
  return request({
    url: '/mail/listMerchantReceiveMail',
    method: 'get',
    params,
  });
}
